export default __webpack_public_path__ + "static/media/Avatar.e9a8327c.jpg";